module.exports = __webpack_public_path__ + "static/img/payments.6a738f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/payments.png
// module id = gMfg
// module chunks = 2